"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var styles_1 = require("@mui/material/styles");
var DefaultPropsHoC_1 = __importDefault(require("components/Generic/DefaultPropsHoC"));
var Text_1 = __importDefault(require("shared/components/Text"));
var getColor = function (theme, color) {
    var _a, _b;
    return ({
        red: (_a = theme.palette.red) === null || _a === void 0 ? void 0 : _a.main,
        green: (_b = theme.palette.green) === null || _b === void 0 ? void 0 : _b.main,
        primary: theme.palette.text.primary,
        secondary: theme.palette.text.secondary,
    }[color]);
};
var DropdownLabel = (0, styles_1.styled)(Text_1.default, {
    shouldForwardProp: function (prop) { return prop !== 'state'; },
})(function (_a) {
    var theme = _a.theme, _b = _a.color, color = _b === void 0 ? 'secondary' : _b;
    return ({
        color: getColor(theme, color),
        lineHeight: '24px',
        ':hover > a': { color: 'inherit' },
    });
});
exports.default = (0, DefaultPropsHoC_1.default)(DropdownLabel, {
    level: 1,
});
